import React from 'react';
import { StockMonitorTask } from '../../services/stockMonitorService';

interface MonitorStatusHeaderProps {
  monitors: StockMonitorTask[];
  isLoading: boolean;
  batchOperating: boolean;
  startingMonitors: Set<string>;
  stoppingMonitors: Set<string>;
  onBatchStart: () => void;
  onBatchStop: () => void;
  onBatchDelete: () => void;
}

const MonitorStatusHeader: React.FC<MonitorStatusHeaderProps> = ({
  monitors,
  isLoading,
  batchOperating,
  startingMonitors,
  stoppingMonitors,
  onBatchStart,
  onBatchStop,
  onBatchDelete,
}) => {
  const hasStopped = monitors.some((m) => m.status === 'stopped');
  const hasRunning = monitors.some((m) => m.status === 'running');

  return (
    <div className="flex items-center justify-end py-1">
      <div className="flex items-center gap-2">
        {hasStopped && (
          <button
            onClick={onBatchStart}
            disabled={isLoading || batchOperating || startingMonitors.size > 0}
            className="px-3 py-1.5 bg-green-500/20 text-green-300 border border-green-500/50 rounded-lg hover:bg-green-500/30 transition-colors text-xs disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
          >
            {batchOperating && startingMonitors.size > 0 ? (
              <>
                <svg className="w-3 h-3 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
                <span>启动中</span>
              </>
            ) : (
              '批量启动'
            )}
          </button>
        )}
        {hasRunning && (
          <button
            onClick={onBatchStop}
            disabled={isLoading || batchOperating || stoppingMonitors.size > 0}
            className="px-3 py-1.5 bg-red-500/20 text-red-300 border border-red-500/50 rounded-lg hover:bg-red-500/30 transition-colors text-xs disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
          >
            {batchOperating && stoppingMonitors.size > 0 ? (
              <>
                <svg className="w-3 h-3 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
                <span>停止中</span>
              </>
            ) : (
              '批量停止'
            )}
          </button>
        )}
        {hasStopped && !hasRunning && (
          <button
            onClick={onBatchDelete}
            disabled={isLoading || batchOperating}
            className="px-3 py-1.5 bg-orange-500/20 text-orange-300 border border-orange-500/50 rounded-lg hover:bg-orange-500/30 transition-colors text-xs disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
          >
            批量删除
          </button>
        )}
      </div>
    </div>
  );
};

export default MonitorStatusHeader;
